<template>
  <div id="payment">
    <transition name="fade">
      <comp-message
        v-if="showMessage"
        :msgText="messageText"
        :msgSuccess="!messageIsErr"
        :msgError="messageIsErr"
        @closeMsg="showMessage = false"
      />
    </transition>

    <div class="payment-tab">
      <div
        class="tab"
        :class="{ active: paymentTab == 'membership' }"
        @click="changeTab('membership')"
      >
        Membership
      </div>
      <div
        class="tab"
        :class="{ active: paymentTab == 'report' }"
        @click="changeTab('report')"
      >
        Reports
      </div>
      <div
        class="tab"
        :class="{ active: paymentTab == 'payHistory' }"
        @click="changeTab('payHistory')"
      >
        History
      </div>
      <div
        class="tab"
        :class="{ active: paymentTab == 'paySolution' }"
        @click="changeTab('paySolution')"
      >
        Solution
      </div>
    </div>

    <div class="contents">
      <div class="column for-membership" v-if="paymentTab == 'membership'">
        <div
          class="pay-type"
          v-for="pay in paymentList"
          :key="pay.productSeqId"
        >
          <input
            type="radio"
            name="subscription"
            :id="pay.productSeqId"
            :checked="pay.payed"
            @click="buyMembership(pay.productSeqId, pay.price, pay.payed)"
          />
          <label :for="pay.productSeqId">
            <div class="title">
              {{ pay.name }} <span v-if="pay.payed">Current Plan</span>
            </div>
            <div class="info">{{ pay.description }}</div>
            <div class="accent">$ Free</div>
          </label>
        </div>
        <!--        <div class="button-group">-->
        <!--          <div class="button">Unsubscribe</div>-->
        <!--        </div>-->
      </div>
      <div class="column for-membership" v-if="paymentTab == 'report'">
        <!--        <div v-for="pay in paymentList"-->
        <!--             :key="pay.productSeqId">-->
        <!--        <input type="radio" name="Report" :id="`user-${pay + 1}`">-->
        <!--        <label :for="`user-${pay + 1}`">-->
        <!--          <div class="title"><span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><polyline-->
        <!--            points="20 6 9 17 4 12"></polyline></svg></span>{{ pay.name }}-->
        <!--          </div>-->
        <!--          <div class="info">{{ pay.description }}<br/>{{ pay.price }}</div>-->
        <!--          <div class="accent" @click="viewReport">View accent Report</div>-->
        <!--        </label>-->
        <!--        </div>-->
        <div
          class="pay-type"
          v-for="pay in paymentList"
          :key="pay.productSeqId"
          @change="buyButton = pay.payed"
          :class="{ deactive: pay.status == '00020202' }"
        >
          <input
            type="radio"
            name="subscription"
            :id="pay.productSeqId"
            v-if="pay.status == '00020201'"
          />
          <input
            type="radio"
            name="subscription"
            :id="pay.productSeqId"
            v-if="pay.status == '00020202'"
            disabled
          />
          <label :for="pay.productSeqId">
            <div class="title">{{ pay.name }}</div>
            <div class="info" v-if="pay.status == '00020201' && pay.payed">
              {{ pay.description }}<br />
              Purchase completed<br />
              {{ pay.remainDay }} days Left
            </div>
            <div class="info" v-if="pay.status == '00020201' && !pay.payed">
              {{ pay.description }}<br />$
              {{ pay.price }}
            </div>
            <div class="info" v-if="pay.status == '00020202'">
              Coming soon<br />$ {{ pay.price }}
            </div>
            <div
              class="accent"
              @click="viewReport(pay.name, pay.status == '00020201')"
            >
              <span>View Sample Report</span>
            </div>
            <div
              class="buy"
              @click="
                buyReport(pay.productSeqId, pay.price, pay.status == '00020201')
              "
            >
              <span>Buy The Report</span>
            </div>
          </label>
        </div>
        <p>
          Once purchased, your full reports will be sent to the email address
          registered to your account.
        </p>
        <div class="button-group">
          <!-- <div class="button" @click="buyReport()" v-if="!buyButton">
            Buy The Report
          </div> -->
          <div class="button" @click="sendReport()" v-if="buyButton">
            Send The Report
          </div>
        </div>
      </div>

      <div class="column for-history" v-if="paymentTab == 'payHistory'">
        <ul>
          <li v-for="pay in payList" :key="pay.paySeqId">
            <div class="date">{{ String(pay.approveDate).split(' ')[0] }}</div>
            <div class="price">${{ pay.price }}</div>
            <div class="title">{{ pay.productName }}</div>
            <div class="ex-date">
              <a style="cursor: pointer;" @click="downloadReport(pay.paySeqId)">
                Download
              </a>
            </div>
          </li>
        </ul>
      </div>

      <div class="column for-membership" v-if="paymentTab == 'paySolution'">
        <div
          class="pay-type"
          v-for="solution in solutionList"
          :key="solution.slt_id"
        >
          <input type="radio" name="subscription" :id="solution.slt_id" />
          <label :for="solution.slt_id">
            <div class="info">{{ solution.ment }}<br /></div>
            <div class="buy" @click="solutionUrl(solution.url)">
              <span>View Solution</span>
            </div>
          </label>
        </div>
      </div>
    </div>

    <comp-loading v-if="isLoading" :fullscreen="true"></comp-loading>
  </div>
</template>

<script>
import common from '@/utils/common'
import PaymentService from '@/services/payment-service'
import CompMessage from '@/components/CompMessage'
import CompLoading from '@/components/CompLoading'

export default {
  name: 'Payment',
  mixins: [common],
  components: {
    CompMessage,
    CompLoading
  },
  data() {
    return {
      isLoading: false,

      showMessage: false,
      messageText: '',
      messageIsErr: false,

      paymentTab: this.$route.params.paymentTab || 'report',
      paymentList: [],
      payList: [],
      solutionList: [],
      paymentId: this.$route.query.paymentId,
      PayerID: this.$route.query.PayerID,
      membership: false,
      buyButton: false
    }
  },
  created() {
    this.$parent.setNav(true)
    this.$parent.setHeader('Premium Services')
    this.$parent.headerBack = true
    this.$parent.setBottomTab(false)

    this.getPaymentList(this.paymentTab)

    this.completePayment()
  },
  methods: {
    showInfoMessage(message, isError) {
      this.isLoading = false

      this.showMessage = true
      this.messageText = message
      this.messageIsErr = isError || false

      setTimeout(() => {
        this.showMessage = false
        this.messageText = ''
        this.messageIsErr = false
      }, 2000)
    },
    changeTab(type) {
      this.paymentTab = type
      if (type === 'payHistory') {
        this.getPayHistory()
      } else if (type === 'paySolution') {
        this.getPaySolution()
      } else {
        this.getPaymentList(type)
      }
    },
    getPaymentList(type) {
      this.isLoading = true

      PaymentService.getPaymentList(type).then(({ resultCode, resultData }) => {
        this.isLoading = false

        if (resultCode === 0) {
          this.paymentList = resultData.productList
        }
      })
    },
    getPayHistory() {
      this.isLoading = true

      PaymentService.getPaymentDetail().then(({ resultCode, resultData }) => {
        this.isLoading = false
        if (resultCode === 0) {
          this.payList = resultData
        }
      })
    },
    getPaySolution() {
      this.isLoading = true

      PaymentService.getPaySolution().then(({ resultCode, resultData }) => {
        this.isLoading = false

        if (resultCode === 0) {
          this.solutionList = resultData
        }
      })
    },
    buyReport(seqId, price, isEnable = true) {
      if (!isEnable) return
      if (!this.isEmpty(seqId) && !this.isEmpty(price)) {
        this.isLoading = true

        const param = {
          productSeqId: seqId,
          payment: price,
          type: 'report'
        }
        PaymentService.getLink(param).then(({ resultData }) => {
          this.isLoading = false

          if (resultData.links) {
            location.href = resultData.links[1].href
            // } else {
            //   if (data.data === 'DB insert ERROR') {
            //     console.log('처리 필요')
            //   }
          }
        })
      }
    },
    sendReport() {
      // this.isLoading = true
      // const param = {
      //   productSeqId: this.reportSeqId,
      //   payment: this.reportPrice,
      //   type: 'report'
      // }
      // sendReport api
    },
    downloadReport(paySeqId) {
      if (paySeqId) {
        this.isLoading = true

        PaymentService.downloadReport(paySeqId).then(
          ({ resultCode, resultMsg }) => {
            this.showInfoMessage(resultMsg, resultCode !== 0)
          }
        )
      }
    },
    buyMembership(seqId, price, payed) {
      if (payed === false) {
        this.isLoading = true
        const param = {
          productSeqId: seqId,
          payment: price,
          type: 'membership'
        }
        PaymentService.getLink(param).then(({ resultCode }) => {
          this.isLoading = false

          if (resultCode === 0) {
            this.getPaymentList('membership')
          }
        })
      }
    },
    completePayment() {
      this.isLoading = true

      const param = {
        paypalNo: this.paymentId,
        payerId: this.PayerID
      }
      if (this.paymentId != null && this.PayerID != null) {
        PaymentService.paymentDone(param).then(({ resultCode, resultMsg }) => {
          this.isLoading = false

          if (resultCode === 0) {
            this.$parent.showDialog(
              'Report purchase completed',
              resultMsg,
              // 'Report was sent by e-mail.\n Please check your e-mail.\n',
              () => {
                this.$parent.hideDialog()
                this.goPage('payment')
              }
            )
          }
        })
      }
    },
    viewReport(reportName, isEnable) {
      if (this.isEmpty(reportName)) return
      if (!isEnable) return

      var reportURL = ''
      const firstName = reportName.split(' ')[0]
      switch (firstName) {
        case 'COBI':
          reportURL = 'https://api.sumforteams.com:10987/sample/cobi.html'
          break
        case 'PIC':
          reportURL = 'https://api.sumforteams.com:10987/sample/pic.html'
          break
        case 'SELC':
          reportURL = 'https://api.sumforteams.com:10987/sample/selc.html'
      }
      window.open(reportURL, 'sample pdf', 'width=500,height=600')
    },
    solutionUrl(url) {
      window.open(url, 'solution', 'width=500,height=600')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" src="@/scss/payment.scss" scoped></style>
